import { useEffect, useState } from 'react';
import { fetchData, textWithIcon, styles } from './Helpers';
import { ColumnGrouping} from '@refinitiv-ui/efx-grid/extensions';
import { regionMapImg, indexImg, esgEarthImg, searchLightImg, symbologyImg, referenceImg, freeWImg, privateImg, professionalImg, resolveImage } from "../../images/ImageResolver";

function CoverageRegionDropdown({ coverageData }) {
  return(
    <div>
      <ef-layout className="coverage-layout">
        <p className='commentP'>"Below are countries with full or partial  ESG coverage.The countries and regions do not reflect a commercial offering."		</p>
        <table>
            <thead>
              <tr>
                <th>REGION</th>
                <th>COUNTRIES</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Americas</td>
                <td className='td-light-bg'>
                  {coverageData.filter(row => (!row["america"].includes("*Coverage"))).map((row, index) => (
                    row["america"]+" "
                  ))}
                </td>
              </tr>
              <tr>
                <td>Asia Pacific</td>
                <td className='td-light-bg'>
                  {coverageData.map((row, index) => (
                    row["asiaPacific"]+" "
                  ))}
                </td>
              </tr>
              <tr>
                <td>EMEA</td>
                <td className='td-light-bg'>
                  {coverageData.map((row, index) => (
                    row["emea"]+" "
                  ))}
                </td>
              </tr>
            </tbody>
          </table>
      </ef-layout>
    </div>
  );
}

function CoverageIndexDropdown({ coverageData }) {
  return(
    <div>
      <ef-layout className="coverage-layout">
        <p className='commentP'>"Companies listed under the below indicies are part of our ESG coverage."		</p>
        <table>
            <thead>
              <tr>
                <th>INDICES</th>
                <th>INDICES</th>
              </tr>
            </thead>
            <tbody>
              {coverageData.map((row, index) => {
                const midpoint = Math.ceil(coverageData.length / 2);
                return index < midpoint ? (
                  <tr key={index}>
                    <td>{row["indices"] || ''}</td>
                    <td>{coverageData[index + midpoint]?.["indices"] || ''}</td>
                  </tr>
                ) : null;
              })}
            </tbody>
          </table>
      </ef-layout>
    </div>
  );
}

function EndpointsDropdown({ type, endpointData }) {
  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { id: "c1", name: '', field: 'endpoint', width: 2, scalable: true, binding: cellWithMultipleLines, headerBinding: headerWithColor.bind(null, "#FFFFFF") },
      { id: "c2", name: 'Scores', field: 'publicScores', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#F1F3FF"), visible: type === "free" },
      { id: "c21", name: 'Measures & Scores', field: 'publicPackage', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#F1F3FF"), visible: type === "free" },
      { id: "c3", name: 'Scores', field: 'privateScores', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#E0E8FF"), styles: styles, visible: type === "private" },
      { id: "c4", name: 'Measures & Scores', field: 'privatePackage', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#E0E8FF"), styles: styles, visible: type === "private" },
      { id: "c5", name: 'Scores', field: 'professionalScores', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#F1F3FF"), visible: type === "professional" },
      { id: "c6", name: 'Measures & Scores', field: 'professionalPackage', width:1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#F1F3FF"), visible: type === "professional" }
    ]

    function headerWithLink(name, text, i, color, cell) {
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = name;
      content._span2.textContent = text;
      cell.setStyle("background-color", color);
      cell.setContent(content);
    };

    function headerWithColor(color,e){
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        content.appendChild(span);
      }
      content._span.textContent = e.columnDef.getName();
      cell.setStyle("background-color", color);
      cell.setContent(content);
    }
    
    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("button");
        let firstLineText = document.createElement("span");
        firstLine.style.fontWeight = "600";
        firstLine.style.color = "#0f1e8a";
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.style.fontSize = "14px";
        firstLine.style.cursor = "pointer";
        firstLine.style.minHeight = "60px";
        firstLine.style.textAlign = "left";
        firstLineText.textContent = e.data;
        firstLine.appendChild(firstLineText);
        content._firstLine = firstLine;
        content.appendChild(firstLine);
      }
      cell.setContent(content);
    }

    grid.config = {
      columnReorder: true,
      columns: columns,
      rowHeight: 50,
      headerRowHeight: 60,
      dataModel: {
        data: endpointData,
      },
      columnGrouping: {
        groupDefinitions: [
          {
            id: "g1",
            children: ["c2", "c21"],
            render: function(e) {
              var cell = e.cell;
              headerWithLink("PUBLIC", "Non Professional", "free", "#FFFFFF", cell)
            }
          },
          {
            id: "g2",
            children: ["c3", "c4"],
            render: function(e) {
              var cell = e.cell;
              headerWithLink("PRIVATE", "Non Professional", "private", "#F1F3FF", cell)
            }
          },
          {
            id: "g3",
            children: ["c5", "c6"],
            render: function(e) {
              var cell = e.cell;
              headerWithLink("INTERNAL PROFESSIONAL", "Private", "professional", "#FFFFFF", cell)
            }
          },
          {
            id: "g4",
            name: "COMMERCIAL PACKAGE",
            alignment: "center",
            children: ["g1", "g2", "g3"],
            render: function(e) {
              var cell = e.cell;
              var groupNode = e.groupNode;
              cell.setStyle("background-color", "#F1F1F1");
              cell.setStyle("border-right", "1px solid #f5f6f8");
              cell.setStyle("border-bottom", "1px solid #f5f6f8");
              cell.setContent(groupNode.name);
            }
          }
        ]
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
        colIndex: 0,
        sortOrder: "a"
        },
      },
      extensions: [
        new ColumnGrouping()
      ]
    }
  }, [type, endpointData]);
  return(
    <ef-layout className="coverage-layout">
      <efx-grid id="grid" className="esg-grid"></efx-grid>
    </ef-layout>
  );
  
}

function Package({type, pliData, coverageData, endpointData}) {
  const [tab, setTab] = useState("pli");
  const [ddIndex, setDdIndex] = useState(0);
  const filters = {
    "private": "Non- Professional Private Redistribution",
    "professional": "Internal Professional Users"
  }

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setTab("pli")}></ef-tab>
        <ef-tab label="Coverage" value="tab2" onClick={() => setTab("coverage")}></ef-tab>
        <ef-tab label="Endpoints" value="tab3" onClick={() => setTab("endpoints")}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {tab === "pli" && 
          <ef-layout className="geography-layout">
            { type === "free" && <p className='commentP'><b>Note:</b> There is no separate package/PLI for Public Redistribution use case. If customers want to display some data for public display, they must hold an active subscription to the Private Non-Professional Package.</p>}
            { type !== "free" && <table>
              <thead>
                <tr>
                  <th>Package</th>
                  <th>PLI Code</th>
                  <th>PLI Description</th>
                </tr>
              </thead>
              <tbody>
                {pliData.filter(row => filters[type] ? row["type"] === filters[type] : true).map((row, index) => (
                  <tr key={index}>
                    <td>{row["package"]}</td>
                    <td>{row["pliCode"]}</td>
                    <td>{row["pliDescription"]}</td>
                  </tr>
                ))}
              </tbody>
            </table>}
          </ef-layout>
         }  
        {tab === "coverage" &&
        <ef-layout>
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 1 ? 0 : 1)}>
            <ef-panel spacing>
              <img src={regionMapImg} alt="Region" />
              <span>Region</span>
              {ddIndex !== 1 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 1 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 1 && <CoverageRegionDropdown type={type} coverageData={coverageData} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 2 ? 0 : 2)}>
            <ef-panel spacing>
              <img src={indexImg} alt="Index" />
              <span>Index</span>
              {ddIndex !== 2 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 2 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 2 && <CoverageIndexDropdown type={type} coverageData={coverageData.filter(item=>item["indices"]!=="")} />}
        </ef-layout>
        }
        {tab === "endpoints" &&
        <ef-layout>
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 1 ? 0 : 1)}>
            <ef-panel spacing>
              <img src={esgEarthImg} alt="ESG" />
              <span>ESG</span>
              {ddIndex !== 1 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 1 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 1 && <EndpointsDropdown type={type} endpointData={endpointData.filter(item => item.service === "ESG")} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 2 ? 0 : 2)}>
            <ef-panel spacing>
              <img src={searchLightImg} alt="Search Light" />
              <span>Search Light</span>
              {ddIndex !== 2 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 2 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 2 && <EndpointsDropdown type={type} endpointData={endpointData.filter(item => item.service === "SearchLight")} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 3 ? 0 : 3)}>
            <ef-panel spacing>
              <img src={symbologyImg} alt="Symbology" />
              <span>Symbology</span>
              {ddIndex !== 3 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 3 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 3 && <EndpointsDropdown type={type} endpointData={endpointData.filter(item => item.service === "Symbology")} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 4 ? 0 : 4)}>
            <ef-panel spacing>
              <img src={referenceImg} alt="Entity Reference" />
              <span>Entity Reference</span>
              {ddIndex !== 4 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 4 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 4 && <EndpointsDropdown type={type} endpointData={endpointData.filter(item => item.service === "Entity Reference")} />}
        </ef-layout>
        }
      </ef-layout>
    </div>
  );
}

export default function WealthPackages() {
  const [packageLayout, setPackageLayout] = useState("free");
  const [pliData, setPliData] = useState([]);
  const [coverageData, setCoverageData] = useState([]);
  const [endpointData, setEndpointData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  
  useEffect(() => {
    Promise.all([
      fetchData("ESG_PLIs"),
      fetchData("Esg_Coverage"),
      fetchData("Package_Endpoint_Mapping")
    ]).then(([pliRes, coverageRes, endpointRes]) => {
      setPliData(pliRes);
      setCoverageData(coverageRes);
      setEndpointData(endpointRes);
      setDataLoaded(true);
    });
  }, []);

  useEffect(() => {
    const buttonBar = document.getElementById('wealthBar');
    buttonBar.addEventListener('click', (event) => {
      let buttonId = '';
      if(event.target.getAttribute('id')) {
        buttonId = event.target.getAttribute('id');
      }else {
        buttonId = event.target.parentElement.getAttribute('id');
      }
      const buttons = buttonBar.querySelectorAll('ef-button');
      buttons.forEach(btn => {
        btn.active = false;
        btn.children[0].src = resolveImage(btn.getAttribute('id'));
      });
      const btn = document.getElementById(buttonId);
      btn.active = true;
      btn.children[0].src = resolveImage(`${buttonId}-w`);
      setPackageLayout(buttonId);
    });
  }, []);

  return (
    <div className='wealth-packages'>
      <ef-loader class="loader" hidden={dataLoaded}></ef-loader>
      <h4>WEALTH PACKAGES</h4>
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              <ef-button id="free" toggles active><img src={freeWImg} alt="Public"/>Public</ef-button>
              <ef-button id="private" toggles><img src={privateImg} alt="Private"/>Private</ef-button>
              <ef-button id="professional" toggles><img src={professionalImg} alt="Professional"/>Professional</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      {packageLayout === "free" && <Package type="free" pliData={pliData} coverageData={coverageData} endpointData={endpointData} />}
      {packageLayout === "private" && <Package type="private" pliData={pliData} coverageData={coverageData} endpointData={endpointData} />}
      {packageLayout === "professional" && <Package type="professional" pliData={pliData} coverageData={coverageData} endpointData={endpointData} />}
    </div>
  );
}